import React from 'react';
import { Block } from 'baseui/block';
import { Button, KIND, SIZE as BUTTONSIZE } from 'baseui/button';
type PropT = {
  onRetry?: () => void;
  errorMessage?: string;
  buttonText?: string;
};
const ErrorMessage = ({
  onRetry,
  errorMessage,
  buttonText
}: PropT) => {
  return <>
      <Block as="h5">{`${errorMessage || 'Unknown Error'}`}</Block>
      {onRetry && <Button kind={KIND.secondary} size={BUTTONSIZE.mini} onClick={() => onRetry()}>
          {buttonText || 'Retry'}
        </Button>}
    </>;
};
export default ErrorMessage;